module.exports = __webpack_public_path__ + "static/capsule-preview-champlain-4.81dd2179.png";


//////////////////
// WEBPACK FOOTER
// ./images/capsule-preview-champlain-4.png
// module id = 894
// module chunks = 168707334958949